import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  TableCell,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ClientNavbar from "@/components/general/Navbars/ClientNavbar";
import BackPageButton, { backButtonContainer } from "@/components/general/buttons/BackPageButton";
import ComercialTable from "@/components/comercial/ComercialTable";
import { sharedStyles } from "@/styles/shared";
import { priceFormatter } from "@/utils/priceFormatter";
import orderApi from "@/services/api/Order";
import dayjs from "dayjs";

const PAYMENT_LABELS: Record<string, string> = {
  PIX: "PIX",
  CREDIT_CARD: "Cartão de crédito",
  DEBIT_CARD: "Cartão de débito",
  CREDIT_CARD_EARLY_BUYER: "Cartão de crédito",
  BANK_SLIP: "Boleto bancário",
};

const STATUS_LABELS: Record<string, string> = {
  PAID: "Pago",
  PENDING: "Pendente",
  EXPIRED: "Expirado",
  CANCELED: "Cancelado",
  ACTIVE: "Ativo",
};

const OrdersList = () => {
  const navigate = useNavigate();

  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    orderApi
      .findAll()
      .then((data) => setOrders(Array.isArray(data) ? data : []))
      .catch(() => setError("Erro ao carregar os pedidos."))
      .finally(() => setLoading(false));
  }, []);

  const tableHeader = (
    <TableRow>
      <TableCell align="left">Pedido</TableCell>
      <TableCell align="center">Valor</TableCell>
      <TableCell align="center">Método</TableCell>
      <TableCell align="center">Status</TableCell>
      <TableCell align="right">Data</TableCell>
    </TableRow>
  );

  const tableBody = (
    <>
      {orders.map((order) => (
        <TableRow
          key={order.id}
          hover
          sx={{ cursor: "pointer", "&:last-child td, &:last-child th": { border: 0 } }}
          onClick={() => navigate(`/order-details/${order.id}`)}
        >
          <TableCell align="left">
            <Typography variant="body2" fontWeight={500}>
              #{order.id.slice(0, 8)}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body2" fontWeight={600} color="success.main">
              R$ {priceFormatter(order.amount ?? 0)}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body2">
              {PAYMENT_LABELS[order.payment] || order.payment}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body2">
              {STATUS_LABELS[order.status] || order.status}
            </Typography>
          </TableCell>
          <TableCell align="right">
            <Typography variant="body2" color="text.secondary">
              {dayjs(order.createdAt).format("DD/MM/YYYY")}
            </Typography>
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <ClientNavbar />

      <Box sx={backButtonContainer}>
        <BackPageButton />
      </Box>

      <Box sx={{ ...sharedStyles.clientMainContainer }}>
        <Typography variant="h5" fontWeight="bold" mb={3}>
          Meus pedidos
        </Typography>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : orders.length === 0 ? (
          <Box sx={{ textAlign: "center", mt: 8 }}>
            <Typography variant="body1" color="text.secondary">
              Nenhum pedido encontrado.
            </Typography>
          </Box>
        ) : (
          <ComercialTable header={tableHeader} body={tableBody} />
        )}
      </Box>
    </Box>
  );
};

export default OrdersList;
